import React, { createContext, useContext, ReactNode } from "react";
import useJournalist from "@root/hooks/useJournalist";

const defaultState: allAnyTypes = {
  fetchJournalists: () => {},
  journalists: [],
  getJournalists: () => {},
  journalistsData: [],
  loader: false,
  setLoader: () => {},
};

const JournalistContext = createContext<allAnyTypes>(defaultState);

interface JournalistProviderProps {
  children: ReactNode;
}

export const JournalistProvider: React.FC<JournalistProviderProps> = ({
  children,
}) => {
  const Journalist = useJournalist();
  return (
    <JournalistContext.Provider value={Journalist}>
      {children}
    </JournalistContext.Provider>
  );
};

export const useJournalistContext = () => {
  return useContext(JournalistContext);
};
